var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#e15b64",
    height: 40,
    width: 15,
    y: 30,
    x: 17.5
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "18;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "64;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#f8b26a",
    height: 40,
    width: 15,
    y: 30,
    x: 42.5
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.1s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "20.999999999999996;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.1s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "58.00000000000001;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#abbd81",
    height: 40,
    width: 15,
    y: 30,
    x: 67.5
  }, /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "20.999999999999996;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "58.00000000000001;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarLoading);
export default __webpack_public_path__ + "static/media/barLoading.f8786036e0e582421393e98c13ffefe6.svg";
export { ForwardRef as ReactComponent };